import { Button, Spinner } from 'modules/v2/common/AtomicDesign/atoms';

import strings from '../../strings';

const ResolutionWaitStep = ({ failed, onRetry, retrying }) => {
  if (failed) {
    return (
      <div className="flex flex-col items-center gap-3 py-12 text-center" data-testid="mod-resolution-failed">
        <h3 className="text-lg font-semibold">{strings.resolution.failedTitle}</h3>
        <p className="max-w-md text-neutral-500">{strings.resolution.failedBody}</p>
        <Button onClick={onRetry} disabled={retrying} data-testid="mod-resolution-retry">
          {strings.resolution.retry}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3 py-12 text-center" data-testid="mod-resolution-wait">
      <Spinner />
      <h3 className="text-lg font-semibold">{strings.resolution.title}</h3>
      <p className="max-w-md text-neutral-500">{strings.resolution.body}</p>
    </div>
  );
};

export default ResolutionWaitStep;
